import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import {
  searchInventoryProduct,
  updateProductStatus,
} from "../../../services/Inventory/inventory"
import EditProduct from "./edit"
import action from "../../../assets/icons/action.svg"
import { toastSuccess } from "../../../helpers/msg_helper"
import closeIcon from "../../../assets/icons/close.svg"
import ProductFilter from "./filter"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import NumberFormat from "../../../utils/numberFormat"
import { capitalize } from "lodash"
import { useLocation, useNavigate } from "react-router-dom"

const Product = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Product${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const [editClass, setEditClass] = useState({
    modal: false,
    value: "",
    id: "",
  })
  const [refresh, setRefresh] = useState(0)
  const [viewData, setViewData] = useState()
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [modal, setModal] = useState(false)

  const navigate = useNavigate()

  const toggle = () => setModal(!modal)
  const desimalrange = localStorage.getItem("desimalrange")

  const handleUpdate = () => {
    setRefresh(refresh + 1)
  }
  const handleReset = () => {
    setEditClass({
      modal: false,
      value: "",
      id: "",
    })
  }

  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [group, setGroup] = useState("")
  const [unitId, setUnit] = useState("")
  const [category, setCategory] = useState("")
  const [page, setPage] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)

  const handleEdit = item => {
    setEditClass({ modal: false, value: item, id: item?.id })
  }
  const handleView = item => {
    setViewData(item)
    toggle()
  }
  const handleActivate = item => {
    const updateStatus = async item => {
      const response = await updateProductStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    }
    updateStatus(item)
  }

  const columns = [
    {
      label: "Product Code",
      renderCell: item => {
        return (
          <>
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "products_view"
            ) ? (
              <>
                <div
                  onClick={() => navigate(`/inventory-book`, { state: { productId: item?.id, productName: item?.description, productCode: item?.product_code, name: crumb } })}
                  // onClick={() => handleView(item)}
                  className="pointer fw-bold"
                // id={`PopoverLegac-${item?.id}`}
                >
                  {item?.product_code}
                </div>
                {/* <UncontrolledPopover
                  placement="bottom"
                  target={`PopoverLegac-${item?.id}`}
                  trigger="hover"
                  className="popover-inset"
                >
                  <PopoverBody>
                    <div className="table-popup-content">
                      {item?.description}
                    </div>
                  </PopoverBody>
                </UncontrolledPopover> */}
              </>
            ) : (
              <div>{item?.product_code}</div>
            )}
          </>
        )
      },
      sortKey: "product_code",
    },
    {
      label: "Product Name",
      renderCell: item => (
        <div>
          <div
            className="capitalize-letter tbl-word-break"
            id={`product-popover-${item?.id}`}
          >
            {item?.description ? (
              item.description.length > 25 ? (
                <div>{capitalize(item.description.slice(0, 25))}...</div>
              ) : (
                <div>{capitalize(item.description)}</div>
              )
            ) : (
              <div>-</div>
            )}
          </div>
          {item?.description && item.description.length > 25 && (
            <UncontrolledPopover
              placement="bottom"
              target={`product-popover-${item?.id}`}
              trigger="hover"
            >
              <PopoverBody>
                <div>{capitalize(item.description)}</div>
              </PopoverBody>
            </UncontrolledPopover>
          )}
        </div>
      ),
      sortKey: "description",
    },
    // {
    //   label: "Part Number",
    //   renderCell: item => item?.part_number,
    // },
    // {
    //   label: "Part Number",
    //   renderCell: item => item?.part_number,
    // },
    // {
    //   label: "Cat Code",
    //   renderCell: item => {
    //     return (
    //       <>
    //         {" "}
    //         <div id={`PopoverLegacy-${item?.category?.category_code}`}>
    //           {item?.category?.category_code}
    //         </div>
    //         <UncontrolledPopover
    //           placement="bottom"
    //           target={`PopoverLegacy-${item?.category?.category_code}`}
    //           trigger="hover"
    //         >
    //           <PopoverBody>
    //             <div className="table-popup-content">
    //               {item?.category?.description}
    //             </div>
    //           </PopoverBody>
    //         </UncontrolledPopover>
    //       </>
    //     )
    //   },
    // },
    {
      label: "Group",
      renderCell: item =>
        item?.group?.description ? capitalize(item?.group?.description) : "-",
      // sortKey: "group_label",
    },
    {
      label: "Product Type",
      renderCell: item =>
        item?.group?.type?.label ? capitalize(item?.group?.type?.label) : "-",
      // sortKey: "group_label",
    },
    // {
    //   label: "B Code",
    //   renderCell: item => {
    //     return (
    //       <>
    //         <div>
    //           {item?.brands?.description ? item?.brands?.description : "-"}
    //         </div>
    //       </>
    //     )
    //   },
    // },
    // {
    //   label: "T Code",
    //   renderCell: item =>
    //     item?.types?.description ? item?.types?.description : "-",
    // },
    {
      label: "Unit Code",
      renderCell: item => {
        return (
          <>
            {/* <div id={`PopoverLegacy-${item?.unit?.unit_code}`}> */}
            {item?.unit?.unit_code ? item?.unit?.unit_code?.toUpperCase() : "-"}
            {/* </div>
            <UncontrolledPopover
              placement="bottom"
              target={`PopoverLegacy-${item?.unit?.unit_code}`}
              trigger="hover"
            >
              <PopoverBody>
                <div className="table-popup-content">
                  {item?.unit?.description}
                </div>
              </PopoverBody>
            </UncontrolledPopover> */}
          </>
        )
      },
    },
    {
      label: <div className="text-end pe-5">Buying Price (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.min_buy_price), desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Selling Price (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.price_aed), desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 &&
                loggedUser?.permission?.some(
                  permissionItem => permissionItem?.name === "products_edit"
                ) && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                )}
              <div
                className={`${item?.status === 1 ? "popover-border" : ""
                  } table-popup-content`}
                onClick={() => handleActivate(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchInventoryProduct({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${search ? `&searchText=${search}` : "&searchText"
          }${`&sortOrder=asc`}${group ? `&group_id=${group}` : ""}${unitId ? `&unit_id=${unitId}` : ""
          }${category ? `&category_id=${category}` : ""}${page ? `&page=${page}` : ""
          }${`&sizePerPage=16`}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
    
  }, [refresh, status, search, group, unitId, category, page, dataPerPage])

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleGroupChange = id => {
    setGroup(id)
    setPage(1)
  }
  const handleUnitChange = id => {
    setUnit(id)
    setPage(1)
  }
  const handleCatChange = id => {
    setCategory(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Inventory"
              breadcrumbObject={[
                { title: "Inventory", link: "/inventory" },
                { title: crumb || "Inventory Masters", link: "/inventory" },
                { title: "Products", link: "/inventory-product" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "products_create"
            ) && (
                <EditProduct
                  key={"x"}
                  onUpdate={handleUpdate}
                  onReset={handleReset}
                  editValue={editClass}
                  buttonLabel="+&nbsp; Products"
                  className="px-2 mb-3 me-2 btn btn-primary"
                />
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <ProductFilter
              handleRefresh={handleUpdate}
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleGroupChange={handleGroupChange}
              handleUnitChange={handleUnitChange}
              // handleCatChange={handleCatChange}
              sampleUrl={"download/products.xlsx"}
              importUrl={"products/import"}
              isExport={
                loggedUser?.permission?.some(
                  permissionItem => permissionItem?.name === "products_create"
                )
                  ? true
                  : false
              }
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                  {classData && (
                    <UpdateTable
                      className="mt-5"
                      nodes={classData?.data?.data}
                      paginate={classData?.data}
                      columns={columns}
                      CurrentPage={page}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="10% 20% 10% 8% 8% 12% 12% 10% 10%"
                      mobileWidth="30% 30% 30% 30% 20% 20% 20% 20% 20%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-4 editmodelheadtitle">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Product Code
              </Col>
              <Col className="primary-text">{viewData?.product_code}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Part Number
              </Col>
              <Col className="primary-text">
                {viewData?.part_number ? viewData?.part_number : "-"}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Product Name
              </Col>
              <Col className="primary-text">
                {viewData?.description
                  ? capitalize(viewData?.description)
                  : "-"}
              </Col>
            </Row>
            {/* <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Base Code
              </Col>
              <Col className="primary-text">{viewData?.description}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Category Code
              </Col>
              <Col className="primary-text">
                {viewData?.category?.category_code}
              </Col>
            </Row> */}
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Group
              </Col>
              <Col className="primary-text">
                {viewData?.group?.description
                  ? viewData?.group?.description
                  : "-"}
              </Col>
            </Row>
            {/* <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Brand Code
              </Col>
              <Col className="primary-text">
                {viewData?.brands?.description
                  ? viewData?.brands?.description
                  : "-"}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Type Code
              </Col>
              <Col className="primary-text">
                {viewData?.types?.description
                  ? viewData?.types?.description
                  : "-"}
              </Col>
            </Row> */}
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Unit Code
              </Col>
              <Col className="primary-text">
                {viewData?.unit?.description
                  ? viewData?.unit?.description
                  : "-"}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Selling Price (AED)
              </Col>
              <Col className="primary-text">
                {viewData?.price_aed
                  ? NumberFormat(
                    Number(viewData?.price_aed),
                    desimalrange,
                    desimalrange
                  )
                  : "-"}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Buying Price (AED)
              </Col>
              <Col className="primary-text">
                {viewData?.price_aed
                  ? NumberFormat(
                    Number(viewData?.min_buy_price),
                    desimalrange,
                    desimalrange
                  )
                  : "-"}
              </Col>
            </Row>
            {/* <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Min Selling Price (AED)
              </Col>
              <Col className="primary-text">
                {viewData?.price_aed
                  ? NumberFormat(
                      Number(viewData?.min_sell_price),
                      desimalrange,
                      desimalrange
                    )
                  : "-"}
              </Col>
            </Row> */}
          </ModalBody>
        </>
      </Modal>
    </React.Fragment>
  )
}

export default Product
